<app-confirm-action-modal
  title="Add New Card"
  message="The card is saved to the customer's wallet."
  confirmLabel="Save card"
  busyLabel="Saving..."
  cancelButtonClass="btn-outlined"
  [busy]="saving"
  [confirmDisabled]="!canSave"
  [closeOnOverlayClick]="false"
  [mobileSheet]="false"
  testId="add-card-modal"
  (confirm)="save()"
  (cancel)="cancel.emit()"
>
  <div class="add-card" [class.add-card--preparing]="preparing">
    <div class="add-card__group">
      <span class="add-card__label">Card number</span>
      <div #cardNumberHost class="add-card__field" data-testid="add-card-number"></div>
    </div>

    <div class="add-card__row">
      <div class="add-card__group">
        <span class="add-card__label">Expiry</span>
        <div #cardExpiryHost class="add-card__field" data-testid="add-card-expiry"></div>
      </div>
      <div class="add-card__group">
        <span class="add-card__label">CVV</span>
        <div #cardCvcHost class="add-card__field" data-testid="add-card-cvc"></div>
      </div>
    </div>

    @if (preparing) {
      <p class="add-card__status" aria-live="polite">Preparing secure card fields...</p>
    }
    @if (errorMessage) {
      <p class="add-card__error" role="alert" data-testid="add-card-error">{{ errorMessage }}</p>
    }

    <p class="add-card__secure">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <rect x="3" y="7" width="10" height="7" rx="1.5" stroke="currentColor" stroke-width="1.3" />
        <path
          d="M5.5 7V5a2.5 2.5 0 015 0v2"
          stroke="currentColor"
          stroke-width="1.3"
          stroke-linecap="round"
        />
      </svg>
      Card details are entered in secure fields hosted by our payment processor.
    </p>
  </div>

  <button
    modalFooterExtra
    type="button"
    class="btn btn-large btn-secondary add-card__back"
    data-testid="add-card-back"
    [disabled]="saving"
    (click)="back.emit()"
  >
    Back
  </button>
</app-confirm-action-modal>
